import { useL10n } from '@uplift/hooks';
import { Alert } from '../../../../Alert';
import { useFormContext } from '../AddSessionForm.types';


export const InvitationAlert = () => {
  const l10n = useL10n();
  const formikContext = useFormContext();
  const isInvite = formikContext.values.isNewPatient;

  if (isInvite) {
    return (
      <Alert severity="info" icon={false}>
        {l10n.schedule.createAppointment.patientInvitationAlert}
      </Alert>
    );
  }

  return null;
};
